<template>
	<div class="deprecated-input" :class="{'is-focus': isFocused, 'is-read-only': readonly}">
		<label v-if="showLabel" class="label" :for="id">{{ name }}</label>
		<template v-if="readonly && type === 'url' && value">
			<a :href="value" target="_blank">{{ value }}</a>
		</template>
		<template v-else-if="readonly">
			{{ value || "&nbsp;" }}
		</template>
		<el-input
			v-else-if="mask"
			:id="id"
			ref="input"
			v-mask="mask"
			:type="type"
			v-bind="$attrs"
			:value="value"
			:placeholder="placeholder"
			@input="$emit('input', $event)"
			@change="$emit('change', $event)"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', $event)"
		/>
		<el-input
			v-else
			:id="id"
			ref="input"
			v-bind="$attrs"
			:type="type"
			:value="value"
			:placeholder="placeholder"
			@input="$emit('input', $event)"
			@change="$emit('change', $event)"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', $event)"
		/>
		<span v-if="$slots['help-text']" class="input__help-text"><slot name="help-text" /></span>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { Input } from '@cognitoforms/element-ui';
	import { mask } from 'vue-the-mask';
	import focus from '../../mixins/focus.ts';

	Vue.directive('mask', mask);
	Vue.use(Input);

	export default {
		name: 'CInput',
		mixins: [focus],
		inheritAttrs: false,
		props: {
			showLabel: { type: Boolean, default: false },
			value: { type: [String, Number], default: '' },
			name: { type: String, default: '' },
			type: { type: String, default: 'text' },
			mask: { type: String, default: null },
			id: { type: String, default: null },
			placeholder: { type: String, default: '' },
			readonly: Boolean
		}
	};
</script>

<style lang="scss" src="@cognitoforms/styles/website/inputs.scss"></style>
